import {AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import PivotGridDataSource from 'devextreme/ui/pivot_grid/data_source';
import {DxChartComponent, DxPivotGridComponent} from 'devextreme-angular';
import {filter, sum, values} from 'lodash';
import {area, union, polygon, multiPolygon} from '@turf/turf';

@Component({
  selector: 'app-fields-interventions-operations-progress-report',
  templateUrl: './fields-interventions-operations-progress-report.component.html',
  styleUrls: ['./fields-interventions-operations-progress-report.component.scss']
})
export class FieldsInterventionsOperationsProgressReportComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input()
  toolbarDs: DataSource;

  @Input()
  dataSource: PivotGridDataSource;

  @Input()
  currentReportType: any;

  @Input()
  reportCurrentViewModes: any;

  @ViewChild(DxChartComponent, {static: false})
  chart: DxChartComponent;

  @ViewChild(DxPivotGridComponent, {static: false})
  pivotGrid: DxPivotGridComponent;

  @Input()
  width: number;

  @Input()
  height: number;
  chartHeight: number;

  constructor() {
  }

  ngOnInit(): void {

    // Set fields
    this.dataSource.fields([{
      caption: 'BU',
      width: 120,
      dataField: 'business_unit_name',
      allowFiltering: true,
      area: 'filter',
    }, {
      caption: 'Domaine',
      width: 120,
      dataField: 'domain_name',
      allowFiltering: true,
      area: 'filter',
    }, {
      caption: 'Operation',
      dataField: 'trailer_operation_type',
      width: 150,
      allowFiltering: true,
      area: 'row'
    }, {
      caption: 'Parcelle',
      dataField: 'field.name',
      width: 150,
      allowFiltering: true,
      area: 'row'
    }, {
      caption: 'Culture',
      dataField: 'crop.name',
      width: 150,
      allowFiltering: true,
      area: 'row'
    }, {
      caption: 'Année',
      dataField: 'start_time',
      dataType: 'date',
      groupInterval: 'year',
      area: 'column'
    }, {
      caption: 'Mois',
      dataField: 'start_time',
      dataType: 'date',
      groupInterval: 'month',
      area: 'column'
    }, {
      caption: 'Jour',
      dataField: 'start_time',
      dataType: 'date',
      groupInterval: 'day',
      area: 'column'
    }, {
      caption: 'Progression',
      dataType: 'number',
      summaryType: 'avg',
      calculateSummaryValue: (cell) => {
        const rawCell = cell as any;
        if (!rawCell.hasOwnProperty('_cell')) {
          return 0;
        }
        return rawCell._cell[1] / rawCell._cell[2];
      },
      format: 'percent',
      area: 'data'
    }, {
      caption: 'Superficie Travaillée Ha',
      // dataField: 'working_area_ha',
      dataType: 'number',
      // summaryType: 'sum',
      summaryType: 'custom',
      calculateCustomSummary: (options) => {
        switch (options.summaryProcess) {
          case 'start':
            // Initializing "totalValue" here
            options.totalValue = polygon([]);
            break;
          case 'calculate':
            // Modifying "totalValue" here
            options.totalValue = union(options.totalValue, multiPolygon(options.value.working_multipolygon));
            break;
          case 'finalize':
            // Assigning the final value to "totalValue" here
            options.totalValue = area(options.totalValue) / 10000;
            break;
        }
      },
      format: {type: 'fixedPoint', precision: 2},
      area: 'data'
    }, {
      caption: 'Superficie Cultivée Ha',
      // dataField: 'field_crop_cadastral_area',
      dataType: 'number',
      // summaryType: 'sum'
      summaryType: 'custom',
      calculateCustomSummary: (options) => {
        switch (options.summaryProcess) {
          case 'start':
            // Initializing "totalValue" here
            options.totalValue = {};
            break;
          case 'calculate':
            // Modifying "totalValue" here
            if (!options.totalValue.hasOwnProperty(options.value.field.id)) {
              options.totalValue[options.value.field.id] = options.value.field_crop_cadastral_area;
            }
            break;
          case 'finalize':
            // Assigning the final value to "totalValue" here
            options.totalValue = sum(values(options.totalValue));
            break;
        }
      },
      area: 'data'
    }, {
      caption: 'Debit horaire Ha/h',
      dataField: 'working_hectare_per_hour',
      dataType: 'number',
      summaryType: 'avg',
      format: {type: 'fixedPoint', precision: 2},
      area: 'data'
    }]);

    this.chartHeight = filter(this.dataSource.fields(), (f) => {
      return f.area === 'data' && f.visible !== false;
    }).length * 350;

    this.toolbarDs.store().push([{
      type: 'update',
      data: {
        options: {
          onClick: () => {
            this.pivotGrid.instance.getFieldChooserPopup().show();
          }
        }
      },
      key: 'filter',
    },
      {
        type: 'update',
        data: {
          options: {
            onClick: () => {
              this.dataSource.reload();
            }
          }
        },
        key: 'refresh',
      }]);
  }

  ngAfterViewInit(): void {
    this.pivotGrid.instance.bindChart(this.chart.instance, {
      dataFieldsDisplayMode: 'singleAxis',
      alternateDataFields: false,
      inverted: true,
      customizeSeries: (seriesName, seriesOptions) => {
        return seriesOptions; // This line is optional
      },
      customizeChart: (chartOptions) => {
        return chartOptions; // This line is optional
      },
    });

    // Assign the data source
    this.pivotGrid.instance.option('dataSource', this.dataSource);
  }

  customizeTooltip(args) {
    return {
      html: args.seriesName + ': ' + args.value
    };
  }

  ngOnDestroy(): void {
  }
}
